import React from 'react';

const Certificates = () => {
  return (
    <div style={{
      background: '#ffffff',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <h1 style={{
        fontSize: '4rem',
        fontWeight: 700,
        color: '#1a1a1a',
        textAlign: 'center',
        letterSpacing: '-1px',
        lineHeight: '1.2'
      }}>
        Coming Soon<br />In Completion Of Bootcamp
      </h1>
    </div>
  );
};

export default Certificates;
